// Asistencia de redacción (RF-E2) sobre TanStack Query.
//
// Son MUTACIONES y no queries: pedir una mejora tiene un efecto —cuesta una
// llamada paga y deja una corrida registrada—, así que no puede reintentarse
// ni refrescarse solo, que es justo lo que una query hace.

import { useMutation } from "@tanstack/react-query";

import {
  mejorarRedaccionRequest,
  redactarDesdeTerrenoRequest,
  resolverPropuestaRequest,
  type CampoRedactableDesdeTerreno,
  type MejorarRedaccionInput,
  type ResultadoDeLaPropuesta,
} from "@/lib/ia";

export function useMejorarRedaccion() {
  return useMutation({
    mutationFn: (input: MejorarRedaccionInput) => mejorarRedaccionRequest(input),
  });
}

/** "Redactar desde terreno": una mutación por lo mismo que `useMejorarRedaccion`. */
export function useRedactarDesdeTerreno(informeId: number) {
  return useMutation({
    mutationFn: (campo: CampoRedactableDesdeTerreno) =>
      redactarDesdeTerrenoRequest(informeId, campo),
  });
}

/**
 * Registra si la persona aceptó o descartó la propuesta.
 *
 * No invalida ninguna cache a propósito: lo que escribe es auditoría, y
 * ninguna pantalla la lee todavía. Y si falla, no se le avisa a nadie — ver
 * `CampoConAsistencia`: la persona ya obtuvo lo que quería.
 */
export function useResolverPropuesta() {
  return useMutation({
    mutationFn: ({
      ejecucionId,
      resultado,
    }: {
      ejecucionId: number;
      resultado: ResultadoDeLaPropuesta;
    }) => resolverPropuestaRequest(ejecucionId, resultado),
  });
}
